<template>
  <VehicleBaseLayout>
    <router-view v-slot="{ Component }">
      <transition name="slide" mode="out-in">
        <div id="showcase-result-app" :class="isMobile() ? 'mobile' : ''">
          <component :is="Component" />
        </div>
      </transition>
    </router-view>
  </VehicleBaseLayout>
</template>

<script>
import { mapActions } from "vuex";
import PlatformsMixins from "@/mixins/PlatformsMixins";
import { mapMutations } from "vuex";
import {countsLeftMenu} from "@/services/api/BuyerServiceApi";
import VehicleBaseLayout from "@/layouts/VehicleBaseLayout.vue";

export default {
  name: "DashboardShowcase",
  components: {VehicleBaseLayout},
  mixins: [PlatformsMixins],
  methods: {
    ...mapActions("buyer", ["getCountsLeftMenu"]),
    ...mapMutations("global", ["setCurrentMainMenu"]),
    ...mapMutations("buyer", ["setResultCountsLeftMenu"]),
    ...mapMutations("filterShowcase", ["setTitleBreadcrumb"]),
    async getBuyerDetailsData() {
      countsLeftMenu()
          .then((response) =>
              this.setResultCountsLeftMenu(response)
          );
    },
  },
  mounted() {
    this.getBuyerDetailsData();
    this.$emitter.on('refreshEvent', (from) => {
      if (from === 'ReleasePaymentViewModal') {
        this.getBuyerDetailsData();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: v-bind(slideLeaveActive);
}
.slide-enter-from,
.slide-leave-to {
  opacity: v-bind(slideLeaveToOpacity);
  transform: v-bind(slideLeaveToTransform);
}

#showcase-result-app {
  flex: 78;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
  height: v-bind(contentHeightWithButtonFooter);
  &.mobile{
    padding-left: 0;
    padding:0 .5em;
  }
}
</style>
